import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'

// Actions
import { actions as collectionsActions } from 'modules/collections/actions'

// Components
import { MiniSpinner, Link, IconCollection, IconRemove } from '@tracklib/kit'

// Hooks
import { useRequest } from 'modules/requests/hooks'

import styles from './minicollection.css'

type MiniCollectionProps = {
  id: number
  title: string
  loading?: boolean
}

const MiniCollection = ({ id, title, loading }: MiniCollectionProps): JSX.Element => {
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const addTrackToCollectionRequest = useRequest('COLLECTION_ADD', String(id))

  const to = `/collection/${id}`

  const deleteCollection = () => {
    if (window.confirm('Are you sure you want to remove the collection?')) {
      // redirect to inpsiration if on that collections page, otherwise don't redirect
      dispatch(collectionsActions.deleteCollection(id, pathname.startsWith(to) ? '/inspiration/' : undefined))
    }
  }

  return (
    <li className={styles.collection} key={id}>
      {!loading && id && title && (
        <Link className={styles.link} activeClassName={styles.active} to={to}>
          <div className={styles.icon}>
            {addTrackToCollectionRequest.isLoading ? (
              <MiniSpinner borderWidth={2} className={styles.spinner} colored />
            ) : (
              <IconCollection />
            )}
            <button
              onClick={e => {
                e.preventDefault()
                return deleteCollection()
              }}
              className={styles.removeIcon}
            >
              <IconRemove />
            </button>
          </div>
          <span className={styles.title}>{title}</span>
        </Link>
      )}
    </li>
  )
}

export default MiniCollection
